// table-cell — wireframe skin module (RUN-407: native table redesign)
// Cell content is projected into native <td> via manual slot assignment.
// role="cell" removed — native <td> provides the implicit role.

export const styles = `
  :host {
    display: contents;
  }

  [part="base"] {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-block: var(--_run-table-cell-padding-v, var(--run-space-semantic-sm));
    padding-inline: var(--_run-table-cell-padding-h, var(--run-space-semantic-md));
    font-size: var(--_run-table-font-size, var(--run-font-size-sm));
    font-weight: 400;
    font-family: var(--run-wf-font-family);
    color: var(--run-wf-text);
    text-align: var(--_run-table-cell-align, start);
    justify-content: var(--_run-table-cell-align, start);
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<div part="base"><slot></slot></div>`;
}
